import { useStyles } from "@b2bportal/core-themes";
import { APAC_CHECKOUT_NAME, ApacCheckoutComponent } from "@apac/checkout";

export const useApacCheckoutStyles = (
  componentName: keyof typeof ApacCheckoutComponent,
  defaultStyles?: object
) => {
  return useStyles(APAC_CHECKOUT_NAME, componentName, defaultStyles);
};
